import { Loadable } from '@/components/loaders';
import { Card } from '@/lib';
import { TranslationKeysByPath } from '@/localization';
import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

type DataSourceOverviewCardProps = {
  title: TranslationKeysByPath<'data_source_details'>;
  isLoading: boolean;
} & PropsWithChildren;

export const DataSourceOverviewCard: FC<DataSourceOverviewCardProps> = ({ title, isLoading, children }) => {
  const { t } = useTranslation('data_source_details');

  return (
    <Card className='z-20 min-h-[106px] w-1/3 flex-col gap-2 rounded-xl p-5'>
      <p className='text-sm font-medium text-tertiary-600'>{t(title as any)}</p>
      <Loadable className='justify-center' spinnerClassName='size-6' isLoading={isLoading}>
        {children}
      </Loadable>
    </Card>
  );
};
